
import { defineComponent, ref, watch } from "vue";

export default defineComponent({
    props: {
        value: {
            type: Boolean,
            default: false
        },
        text: {
            type: String,
            default: ""
        },
        backgroundColor: {
            type: String,
            default: "var(--secondary)"
        },
        foregroundColor: {
            type: String,
            default: "var(--buttonTextColor)"
        }
    },
    emits: ["input"],
    setup(props, { emit }) {
        const isChecked = ref(props.value);

        watch(isChecked, () => {
            emit("input", isChecked.value);
        });

        watch(props, () => {
            if (props.value !== isChecked.value) {
                isChecked.value = props.value;
            }
        });

        const style = ref({
            "--background-color": props.backgroundColor,
            "--foreground-color": props.foregroundColor
        });

        return {
            isChecked,
            style
        };
    }
});
